import { AddressDto, EntityDtoBase, IdNameDto } from './Common'

export interface EmailMessageDto extends EntityDtoBase {
    eventIdName: IdNameDto
    clientIdName: IdNameDto
    subject?: string
    body?: string
    emailRecipient?: string
    state: EmailMessageState
    type: EmailMessageType
}

export interface EmailTemplateDto extends EntityDtoBase {
    subject: string
    bodyTemplate: string
    type: EmailMessageType
    isEnabled: boolean
}

export interface EmailMessageLogDto {
    sentAt?: Date
    type: EmailMessageType
}

export interface SurveyResponseBriefDto {
    id: string
    eventIdName: IdNameDto
    respondentIdName: IdNameDto
    eventStartsAt: Date
    eventEndsAt: Date
    address: AddressDto
    surveyType: SurveyType
    responseCreatedAt: Date
}

export interface SurveyResponseDto extends SurveyResponseBriefDto {
    answers: SurveyAnswerDto[]
}

export interface SurveyAnswerDto {
    questionText: string
    questionType: SurveyQuestionType
    integerAnswer: number | null
    textAnswer: string
    multipleChoicesAnswer: string[]
}

export enum SurveyQuestionType {
    Text,
    Integer,
    SingleChoice,
    MultipleChoices,
}

export enum EmailMessageState {
    NotSet = 0,
    WaitingToBeSent = 1,
    Sent = 2,
}

export enum EmailTemplateType {
    NotSet = 0,
    InvoiceCreated = 1,
}

export enum EmailMessageType {
    NotSet = 0,
    InvoiceCreated = 1,
    EventFinished = 2,
    EventRejected = 3,
    RemindPendingOffer = 4,
    RemindApproachingEventStart = 5,
    RemindNotPaidEvent_Severity1 = 6,
    RemindNotPaidEvent_Severity2 = 7,
    RemindEventRepetition = 8,
    RemindUnrealizedEvent = 9,
}

export enum EventRepetitionReminderMode {
    Disabled = 0,
    Once = 1,
    EveryYear = 2,
}

export enum SurveyType {
    NotSet = 0,
    ClientFeedback = 1,
    EventRejectedFeedback = 2,
}
